export enum OrderStatus {
  Placed = "Placed",
  Collecting = "Collecting",
  AssignedToCompany = "AssignedToCompany",
  PickedUpByCompany = "PickedUpByCompany",
  AssignedToDriver = "AssignedToDriver",
  Active = "Active",
  InDelivery = "InDelivery",
  Expedited = "Expedited",
  Delivered = "Delivered",
  Cancelled = "Cancelled",
  Failed = "Failed",
  ReturnPlaced = "ReturnPlaced",
  ReturnApproved = "ReturnApproved",
  ReturnRejected = "ReturnRejected",
  ReturnBeingPickedUp = "ReturnBeingPickedUp",
  ReturnPickUpFailed = "ReturnPickUpFailed",
  ReturnInDeliveryToWarehouse = "ReturnInDeliveryToWarehouse",
  ReturnDeliveredToWarehouse = "ReturnDeliveredToWarehouse",
  ReturnBeingReviewed = "ReturnBeingReviewed",
  ReturnAwaitsForFullRefund = "ReturnAwaitsForFullRefund",
  ReturnAwaitsCustomerAtWarehouse = "ReturnAwaitsCustomerAtWarehouse",
  ReturnVerified = "ReturnVerified",
  ReturnReadyForDeliveryToCustomer = "ReturnReadyForDeliveryToCustomer",
  ReturnInDeliveryToCustomer = "ReturnInDeliveryToCustomer",
  ReturnFailedToCustomer = "ReturnFailedToCustomer",
  ReturnDeliveredToCustomer = "ReturnDeliveredToCustomer"
}

export const ORDER_STATUSES_LIST = [
  { label: "Placed", value: OrderStatus.Placed, backgroundColor: "#3F8CFF" },
  {
    label: "Collecting",
    value: OrderStatus.Collecting,
    backgroundColor: "#FF9900"
  },
  {
    label: "Assigned to Company",
    value: OrderStatus.AssignedToCompany,
    backgroundColor: "#3F8CFF"
  },
  {
    label: "Picked Up by Company",
    value: OrderStatus.PickedUpByCompany,
    backgroundColor: "#00B8D9"
  },
  {
    label: "Batch Picked Up",
    value: "BatchPickedUp",
    backgroundColor: "#3F8CFF"
  },
  {
    label: "Assigned",
    value: OrderStatus.AssignedToDriver,
    backgroundColor: "#3F8CFF"
  },
  {
    label: "Ready for Delivery",
    value: OrderStatus.Active,
    backgroundColor: "#FB3973"
  },
  {
    label: "Ready for Delivery",
    value: "ReadyForDelivery",
    backgroundColor: "#FB3973"
  },
  {
    label: "On the Way",
    value: OrderStatus.InDelivery,
    backgroundColor: "#FB3973"
  },
  {
    label: "Expedited",
    value: OrderStatus.Expedited,
    backgroundColor: "#7A4DFF"
  },
  { label: "Failed", value: OrderStatus.Failed, backgroundColor: "#FF0033" },
  {
    label: "Delivered",
    value: OrderStatus.Delivered,
    backgroundColor: "#16C350"
  },
  {
    label: "Cancelled",
    value: OrderStatus.Cancelled,
    backgroundColor: "#FF0033"
  },
  {
    label: "Return Placed",
    value: OrderStatus.ReturnPlaced,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Approved",
    value: OrderStatus.ReturnApproved,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Rejected",
    value: OrderStatus.ReturnRejected,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Picking Up",
    value: OrderStatus.ReturnBeingPickedUp,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Pick Up Failed",
    value: OrderStatus.ReturnPickUpFailed,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Coming",
    value: OrderStatus.ReturnInDeliveryToWarehouse,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return in Warehouse",
    value: OrderStatus.ReturnDeliveredToWarehouse,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Reviewing",
    value: OrderStatus.ReturnBeingReviewed,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Awaits Customer",
    value: OrderStatus.ReturnAwaitsCustomerAtWarehouse,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Verified",
    value: OrderStatus.ReturnVerified,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Awaiting Refund",
    value: OrderStatus.ReturnAwaitsForFullRefund,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Ready for Delivery",
    value: OrderStatus.ReturnReadyForDeliveryToCustomer,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return In Delivery",
    value: OrderStatus.ReturnInDeliveryToCustomer,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Delivery Failed",
    value: OrderStatus.ReturnFailedToCustomer,
    backgroundColor: "#A8A8BB"
  },
  {
    label: "Return Completed",
    value: OrderStatus.ReturnDeliveredToCustomer,
    backgroundColor: "#A8A8BB"
  }
];
